import { Cell, Grid } from 'bold-ui'
import { Box } from 'components/Box'
import { simNaoEnumToBoolean, SimNaoRadioGroupField, TextField } from 'components/form'
import { useFormState } from 'react-final-form'

import { meta } from './AplicacaoVacinaModal'

export function PesquisaClinicaFields() {
  const { values } = useFormState({ subscription: { values: true } })

  return (
    <>
      <Cell size={6}>
        <SimNaoRadioGroupField name={meta.isPesquisaClinica} label='Pesquisa clínica' required />
      </Cell>
      {simNaoEnumToBoolean[values.isPesquisaClinica] && (
        <Cell size={12}>
          <Box>
            <Grid>
              <Cell size={4}>
                <TextField name={meta.anvisaProtocoloEstudo} label='Anvisa protocolo estudo' maxLength={10} required />
              </Cell>
              <Cell size={4}>
                <TextField name={meta.anvisaProtocoloVersao} label='Anvisa protocolo versão' maxLength={10} required />
              </Cell>
              <Cell size={4}>
                <TextField name={meta.anvisaNumeroRegistro} label='Anvisa número de registro' maxLength={10} required />
              </Cell>
            </Grid>
          </Box>
        </Cell>
      )}
    </>
  )
}
